import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var DigitWidth = /** @class */ (function (_super) {
    __extends(DigitWidth, _super);
    function DigitWidth() {
        return _super.call(this) || this;
    }
    DigitWidth.forceNativeConstructor = true;
    DigitWidth.forceNativeMethods = true;
    // JS -> AS Bindings
    DigitWidth.DEFAULT = 'default';
    DigitWidth.PROPORTIONAL = 'proportional';
    DigitWidth.TABULAR = 'tabular';
    return DigitWidth;
}(ASObject));
export { DigitWidth };
